import React, { useState, useEffect } from 'react'
import { Button, Card, Col, OverlayTrigger, Row, Table, Tooltip } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { deleteNotification } from '../../service/api/notification/deleteNotification'
import { unreadNotificationCount } from '../../service/api/notification/unreadNotification'
import { setCurrentPage, setNotificationCount } from '../../feature/userData/userData'
import { singleNotification } from '../../service/api/notification/singleNotificationDetails'
import { userNotificationCount } from '../../service/api/notification/userNotification'
import AcceptRejectModal from '../../jsx/components/modalAcceptReject/modalAcceptreject';
import PaginationAndSearching from '../../component/paginationAndSearching/paginationAndSearching'
import SkeletonTableRow from '../../component/skeletonTableRow/skeletonTableRow'
import { txtNotifications } from '../../dataBaseFile/label'
import { bulkReadDeleteNotification } from '../../service/api/notification/bulkReadDelete'

const NotificationPage = () => {

  const { profilePicture, notificationCount } = useSelector((state) => state.user);
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [elements, setElements] = useState([])
  const [showThing, setShowThing] = useState(false)
  const [page, setPage] = React.useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [totalPage, setTotalPage] = useState(1)
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [pageIndex, setPageIndex] = useState(1)
  const [nextDisabled, setNextDisabled] = useState(false)
  const [searchArea, setSearchArea] = useState("")
  const [loadingSkelton, setLoadingSekelton] = useState(false)
  const [bulkDeleteArr, setBulkDeleteArr] = useState([])
  const [flag, setFlag] = useState(false);
  const [notificationId, setNotificationId] = useState()
  const [basicModal, setBasicModal] = useState(false);
  const [indexOfId, setIndexOfId] = useState()
  const [customeSkeletonLoaing, setCustomeSkeletonLoaing] = useState(false);

  useEffect(() => {
    dispatch(setCurrentPage("Notifications"))
  }, [])


  const deleteNotifications = (e, index) => {
    // console.log(elements, 'b')
    let array = [...elements]
    array.splice(index, 1)
    setElements(array)
    let details = {
      user_id_ids: localStorage.getItem('user_id'),
      notification_id_ids: e
    }
    dispatch(

      deleteNotification(
        details,
        (res) => {
          setBasicModal(false)

          intialNotificationLoad()
          let details = {
            user_id_ids: localStorage.getItem('user_id'),
          }
          dispatch(
            unreadNotificationCount(details, (res) => {
              dispatch(setNotificationCount(res.data.data.count))
            }),
          )
        },
        () => {

        },
      ),
    )
  }

  const intialNotificationLoad = () => {
    setLoadingSekelton(true)
    setCustomeSkeletonLoaing(true)
    let details = {
      user_id_ids: localStorage.getItem('user_id'),
      page_index: pageIndex,
      page_size: +pageSize,
      order: 'DESC',
      column_name: '',
      search_by: '',
      search_area: searchArea,
    }
    dispatch(
      userNotificationCount(
        details,
        (res) => {
          setCustomeSkeletonLoaing(false)
          setElements(res.data.data)
          if (res.data.total_records % pageSize === 0) {
            setTotalPage(parseInt(res.data.total_records / pageSize))
          } else {
            setTotalPage(parseInt(res.data.total_records / pageSize + 1))
          }
          setLoadingSekelton(false)
          if (res.data.data.length === 0) {


            setTimeout(() => {
              setLoadingSekelton(false)
            }, '3000')
          }
        },
        () => {
          setCustomeSkeletonLoaing(true)
          setTimeout(() => {
            setLoadingSekelton(false)
          }, '3000')
        },
      ),
    )
  }

  const markNotificationRead = (e, i) => {

    navigate('/notificationDetails');

    localStorage.setItem('notifcation_id', e.notification_id_ids)
    let array = [...elements]
    if (array[i].is_read_ysn === 0) {
      array[i].is_read_ysn = 1
      setElements(array)

      let details = {
        user_id_ids: localStorage.getItem('user_id'),
        notification_id_ids: e.notification_id_ids,
      }
      dispatch(
        singleNotification(details, () => {
          let details = {
            user_id_ids: localStorage.getItem('user_id'),
          }
          dispatch(
            unreadNotificationCount(details, (res) => {
              dispatch(setNotificationCount(res))
            }),
          )
        }),
      )
    }
  }



  useEffect(() => {
    intialNotificationLoad()
  }, [pageIndex, pageSize])
  const tooltip = (
    <Tooltip id="tooltip" >
      <strong >Delete</strong>
    </Tooltip>
  );
  const searchAreaVal = (e) => {
    setSearchArea(e.target.value)
    if (searchArea.trim().length >= 2) {
      onChangePage(1)
    }
  }
  const handleChangeRowsPerPage = (e) => {

    setSearchArea('')
    setPageIndex(1)
    setPageSize(e.target.value)
  }
  const onChangePage = (e, p) => {
    setPageIndex(e)
  }

  function onLoadSearch() {
    setLoadingSekelton(true)
    let details = {
      user_id_ids: localStorage.getItem('user_id'),
      page_index: 1,
      page_size: +pageSize,
      order: 'DESC',
      column_name: '',
      search_by: '',
      search_area: searchArea,
    }
    dispatch(
      userNotificationCount(
        details,
        (res) => {

          setElements(res.data.data)
          if (res.data.total_records % pageSize === 0) {
            setTotalPage(parseInt(res.data.total_records / pageSize))
          } else {
            setTotalPage(parseInt(res.data.total_records / pageSize + 1))
          }
          setLoadingSekelton(false)
          if (res.data.data.length === 0) {


            setTimeout(() => {
              setLoadingSekelton(false)
            }, '3000')
          }
        },
        () => {
          setTimeout(() => {
            setLoadingSekelton(false)
          }, '3000')
        },
      ),
    )
  }
  useEffect(() => {

    if (searchArea.trim().length > 2) {
      setFlag(true);
      const timeOutId = setTimeout(onLoadSearch, 1000);
      return () => clearTimeout(timeOutId);
    } else if (searchArea.trim().length === 0) {
      if (flag) {
        onLoadSearch();
      }
    }

  }, [searchArea]);

  function handleReadAllNotification() {
    let data = {
      user_id_ids: localStorage.getItem("user_id"),
      action: "R",
      action_type: "A",
      notification_id_list: []
    }
    dispatch(bulkReadDeleteNotification(data, () => {
      let details = {
        user_id_ids: localStorage.getItem("user_id"),
      };
      dispatch(
        unreadNotificationCount(details, (res) => {

          dispatch(setNotificationCount(res.data.data.count));
        })
      );
    }, () => { }))
  }

  return (
    <div>
      <Row>
        <Col lg={12}>
          <Card className='bg-white'>
            <Card.Header>
              {/* <Card.Title style={{ fontSize: '20px', fontWeight: '700' }}>{txtNotifications}</Card.Title> */}
              {notificationCount > 0 && <div
                className=" d-flex align-items-center"
                style={{
                  justifyContent: "flex-end",
                  // padding: "0.5rem 1.75rem",
                }}>
                <Button
                  className="notification-btn"
                  variant="primary"
                  style={{
                    width: '100%',
                    background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                    border: '2px solid rgba(255, 154, 32, 1)',
                    boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                  }}
                  onClick={handleReadAllNotification}>
                  {`Read All`}
                </Button>
              </div>}
            </Card.Header>
            <Card.Body>
              <PaginationAndSearching
                handleSearch={searchAreaVal}
                searchValue={searchArea}
                defaultValue={pageSize}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                totalCount={totalPage}
                onChange={onChangePage}
              />
              <Table responsive>

                <tbody>

                  {customeSkeletonLoaing ?
                    <SkeletonTableRow cols={3} /> :
                    <>
                      {elements.length > 0 ?
                        <>
                          {elements.map((element, index) => {
                            return (
                              <tr className='notification-rows' key={index} style={{ fontWeight: element.is_read_ysn === 0 ? '600' : '400', color: element.is_read_ysn === 0 ? 'black' : 'gray' }} onClick={() => { markNotificationRead(element, index) }}>
                                <td>
                                  <div className="d-flex align-items-center">
                                    <img
                                      // src={profilePicture}
                                      src={element?.preferred_profile_picture_url}
                                      className="rounded-lg me-2"
                                      width="24"
                                      alt=""
                                    />{" "}
                                    <span className="w-space-no">{element.name}</span>
                                  </div>
                                </td>
                                <td>{element.message_chr}</td>

                                <td>
                                  {element.dateString}
                                </td>
                                <td>
                                  <OverlayTrigger placement="top" overlay={tooltip}>
                                    <div onClick={(e) => {
                                      e.stopPropagation();
                                      setNotificationId(element.notification_id_ids)
                                      setIndexOfId(index)
                                      setBasicModal(true)
                                    }} className="d-flex align-items-center justify-content-center" style={{ color: '#F65160', fontSize: '22px' }}>
                                      <i class="bi bi-trash"></i>
                                    </div>
                                  </OverlayTrigger>
                                </td>
                              </tr>
                            )
                          })}</> :
                        <tr style={{ fontSize: '13px', backgroundColor: '#fff', }}>
                          <td colSpan="3">No Records Found</td>
                        </tr>
                      }
                    </>}



                </tbody>
              </Table>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <AcceptRejectModal text={"Are you sure you want to delete notification ?"}
        onClickReject={() => {
          setBasicModal(false);
        }}
        onClickAccept={() => { deleteNotifications(notificationId, indexOfId) }}
        modalStatus={basicModal} />

      {/* <!-- Modal --> */}

    </div>
  )
}

export default NotificationPage